import { connect } from 'react-redux';
import React, { useState, useEffect, Fragment } from "react";
import BlockHeader from "../../../../component/BlockHeader/BlockHeader";
import ContinueCreateInitiative from "../../../../component/ContinueCreate";
import UserState from "../../../../store/stateMap";
import api from '../../../../api';
import { useSearchParams, useNavigate } from "react-router-dom";
import fancybox, { popinfo } from '../../../../component/Fancybox/Fancybox';
import "../../../../sass/form/form.scss";
import "./style.scss";
import LoginBox from 'component/LoginBox/LoginBox';
import { PageCredential } from 'component/PageCredential';

export default connect(UserState)((props) => {

    let navigate        = useNavigate();
    const [isBinusian, setIsBinusian] = useState(false);
    const[formDataLoad, setFormDataLoad] = useState(true);
    const [readTOC, setReadTOC] = useState(false);
    const [toc, setToc]         = useState(false);
    const[continuedInitiative, setContinuedInitiative] = useState(false);
    let [searchParams]  = useSearchParams();

    const SeeTOC = (e) => {
        e.preventDefault();

        const TOCPop = fancybox(
            <div className="" style={{maxWidth : '640px'}}>
                <div className="wp-content" dangerouslySetInnerHTML={{__html : toc}}/>

                <div className="text-center mt-lg">
                    <button className="btn btn-primary" onClick={() => {
                        TOCPop.close();
                        setReadTOC(true);
                    } }>i Agree</button>
                </div>
                
            </div>
        );

    }

    const NextPage = (e) => {
        e.preventDefault();

        if(!isBinusian || !readTOC)
        {
            popinfo('error', 'Oopss', 'Please Read and Agree on our term and condition');
        }
        else
        {
            navigate({
                pathname : 'choose'
            });
        }


    }

    useEffect(() => {
        if(!props.auth.user)
        {
            return;
        }

        api('/TOC', 'get', {}, 'Bearer ' + props.auth.token)
            .then(response => {
                setToc(response.toc);
            });
    }, [props.auth.user]);

    useEffect(() =>{

        if(props.auth.user === false)
        {
            return;
        }

        if(searchParams.get('id') > 0)
        {
            api('/Initiative','get', {
                id : searchParams.get('id')
            }, 'Bearer ' + props.auth.token)
            .then((response) => {
                
                if(response.initiative[0].InitiatorID == props.auth.user.UserID)
                {
                    setContinuedInitiative(response.initiative[0]);
                }

                setFormDataLoad(false);
            })
        }
        else
        {
            setFormDataLoad(false);
        }
    }, [props.auth.user]);

    return(
        <>
        <PageCredential title="Create Initiative"/>
        {
            props.auth.user ?
            <div id="page-create-initiative-select" className="container w-800">
                <div className="text-center">
                    <span className="block text-xs mb-5">1 of 4</span>
                    <BlockHeader title="First, let’s agree on some things." desc="Please Kindly read our term and conditions &amp; Tell us where you’re based and confirm a few other details before we proceed." />
                </div>
                <div className="mt-5 mb-5">
                    <form action="" className='generic-form'>
                        <label htmlFor="has-read-toc" className='form-control checkbox block'>
                            <input type="checkbox" id="has-read-toc" name="has-read-toc" checked={readTOC} onChange={(e) => {

                                setReadTOC(!readTOC);
                            }} /> 
                            I have read the <a href="" className="color-brand" onClick={SeeTOC}>Term and Conditions.</a>     
                        </label> 
                        <label htmlFor="is-binusian" className='form-control checkbox block'>
                            <input type="checkbox" id="is-binusian" name="is-binusian"  onChange={(e) => {

                                setIsBinusian(!isBinusian);
                            }} /> I can verify that i study/work in BINA NUSANTARA   
                        </label>    
                    </form>
                </div>
                <hr />
                {
                    (formDataLoad || toc === false) ? <span className="skeleton"></span> : 
                    <div className="form-actions">
                        {
                            continuedInitiative ? 
                            <Fragment>
                                <div  >
                                    <button className="btn btn-orange btn-reverse" onClick={NextPage}>Start Over</button>
                                </div> 
                                <div className="text-right">
                                    <ContinueCreateInitiative className="btn btn-orange" sentInitiative={continuedInitiative} />
                                </div>
                            </Fragment>
                            : 
                            <Fragment>
                                <div>
                                    <ContinueCreateInitiative className="btn btn-orange btn-reverse" sentInitiative={continuedInitiative} />
                                </div>
                                <div className="text-right" >
                                    <button className="btn btn-orange" onClick={NextPage}>Next : Lets Set Up</button>
                                </div>
                            </Fragment>
                        }
                    </div>
                }
            </div>
            :
            <div className='container'>
                <LoginBox/>
            </div>
        }
        </>
    )
});